import { render, staticRenderFns } from "./ReleasesMyDraftsList.vue?vue&type=template&id=122b98d6&"
import script from "./ReleasesMyDraftsList.vue?vue&type=script&lang=js&"
export * from "./ReleasesMyDraftsList.vue?vue&type=script&lang=js&"
import style0 from "./ReleasesMyDraftsList.vue?vue&type=style&index=0&id=122b98d6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports